// extracted by mini-css-extract-plugin
export default {"zoomControls":"lca-z","zoomControlButton":"mca-z","zoomBanner":"nca-z","bannerButton":"oca-z","imageButton":"pca-z","zoom":"qca-z","zoomContent":"rca-z"};